import React from 'react';
import styles from './Steps.module.scss';
import Step from './components/step';

interface ISteps {
  steps: string[];
  isAdmin?: boolean;
  activeStep: number;
  setAdminStep: (activeStep: number) => void;
}


const Steps = (props: Partial<ISteps>) => {
  return props.activeStep < props.steps.length ? (
    <div className={styles.Steps}>
      {props.steps.map((step, index) => <Step key={step}
                                              onClick={props.setAdminStep as any}
                                              label={step}
                                              activeStep={props.activeStep} step={index}/>)}
    </div>
  ) : null;
};

Steps.defaultProps = {
  steps: [],
  activeStep: 0,
  isAdmin: false,
  setAdminStep: (activeStep) => {
    
  },
};

export default React.memo(Steps);
